import { isFunction } from 'lodash'
import { AREA_PROPS } from './props/index.js'
import AreaSearch from './layout/area-search.js'
import AreaPanel from './layout/area-panel'
import InputList from './components/input-list.js'
import CityItem from './components/city-item'
import { HOT_CITY_DATA, OTHER_CITIES_COUNTIES } from './data/constant'
import inputClickoutside from './directives/clickoutside'
import { elementDisplayStatus } from './utils/style.js'
import { getLastSubstringAfterDash, getAreaTreeNodeById, transFormConfirmData, getAreaTreeMap } from './data/store.js'
import { formatterAreadResult, isPreventDownOnLevel, isEqualDistricID } from './utils/tools.js'
import { createAreaPopoverPlugin } from './plugins/popover.js'
import './style/index.scss'
import './style/validate.scss'

export default {
  name: 'KyeArea',
  props: AREA_PROPS,
  reportName: 'KyeArea',
  directives: {
    inputClickoutside
  },
  data () {
    const { validate, showInputError, clearValidate, setShowInputErrorStatus } = createAreaPopoverPlugin(this)
    return {
      inputSearchResult: {
        districtList: []
      },
      keyWord: '',
      selected: undefined,
      validate,
      showInputError,
      clearValidate,
      setShowInputErrorStatus,
      inputListStyle: {
        display: 'none'
      }
    }
  },
  render () {
    const props = this.$props
    const commonProps = {
      level: props.level,
      selectFullLevel: props.selectFullLevel,
      showHotCity: props.showHotCity,
      disabled: props.disabled
    }

    const contentProp = {
      ...commonProps,
      hotCity: props.hotCity || HOT_CITY_DATA,
      confirmNextLevel: props.confirmNextLevel
    }


    const contentPopoverProps = props.contentPopoverProps || {}

    const popperClass = 'kye-area-pop-wrap'
    const popoverAttrs = {
      props: {
        visibleArrow: false,
        trigger: 'click',
        width: '500px',
        minWidth: '500px',
        placement: 'bottom-start',
        ...(contentPopoverProps.props || {}),
        popperClass
      },
      ref: 'addressPopRef',
      on: {
        show: () => this.addressPopStatus(1),
        hide: () => this.addressPopStatus(0),
        'after-leave': this.afterLeavePop
      }
    }

    const [slot] = this.$slots.default || []
    const { cityItem } = slot || {}

    const areaPanelSlot = {
      cityItem: (cityProps) => {
        return (
           <CityItem {
            ...{
              props: {
                ...cityProps,
                isSelected: isEqualDistricID(this.selected, cityProps)
              }
            }}>
            {{
              cityItem: cityItem || this.$scopedSlots.cityItem
            }}
          </CityItem>
        )
      },
    }

    const rendeContentComponent = () => {
      const {
        districtList = []
      } = this.inputSearchResult || {}
      const inputListProps = {
        ...commonProps,
        searchList: districtList,
        keyWord: this.keyWord,
        handleSearchListItemClickEvent: this.handleSearchListItemClickEvent,
        inputListStyle: this.inputListStyle
      }
      const inputListAttrs = {
        props: inputListProps,
      }
      const areaPanelAttrs = {
        props: contentProp,
        ref: 'contentLayoutRef',
        style: elementDisplayStatus(!districtList.length),
        on: {
          'area-item-click': this.handleAreaItemClickEvent,
          updateAreaPanel: this.updatePopper
        }
      }
      return [
        <InputList {...inputListAttrs}></InputList>,
        <AreaPanel {...areaPanelAttrs}>
          {
            areaPanelSlot
          }
        </AreaPanel>
      ]
    }

    const content = rendeContentComponent()
    const wrapClass = {
      'kye-area': true,
      'kye-area-disabled': !!props.disabled,
      'kye-area-input-validate-error': this.showInputError
    }
    const renderAreaSearch = () => {
      const seachInputProps = {
        ...commonProps,
        searchOption: props.searchOption,
        placeholder: this.$props.placeholder || (this.$props.selectFullLevel ? '请选择/输入省市区(或行政区号)' : '请选择/输入区域(或行政区号)'),
        handleSearchInputEvent: this.handleSearchInputEvent
      }
      const searchInputAttrs = {
        props: seachInputProps,
        ref: 'searchRef',
        on: {
          clear: this.clearSearchInput,
          keyDown: this.handleSearchKeyDownEvent
        }
      }
      return <AreaSearch
        v-inputClickoutside={this.inputClickoutside}
        {...searchInputAttrs}
        slot='reference'
      ></AreaSearch>
    }
    const search = renderAreaSearch()
    return <div class={wrapClass}>
      <el-popover
        {...popoverAttrs}
      >
        {
          search
        }
        {
          content
        }
      </el-popover>
    </div>
  },
  mounted () {
    this.createPanelBaseData()
  },
  methods: {
    createPanelBaseData () {
      if (this.$refs.contentLayoutRef) {
        this.$refs.contentLayoutRef.createPanelBaseData()
      }
    },
    // 设置输入框模糊搜索时的数据
    setInputSearchResult (result) {
      this.inputSearchResult = result || {
        districtList: []
      }
      this.inputListStyle = elementDisplayStatus(this.inputSearchResult.districtList && this.inputSearchResult.districtList.length)
    },
    // 存储模糊时的label. 高亮逻辑使用
    setKeyWord (keyWord) {
      this.keyWord = keyWord
    },
    // 气泡状态
    setShowPopover (val) {
      if (!val) {
        this.$refs.addressPopRef.doClose()
      } else {
        this.$refs.addressPopRef.doShow()
      }
    },
    // 气泡动画关闭时的回调
    afterLeavePop () {
      // 如果没选中，则清空输入框的内容
      if (!this.selected) {
        this.setInputLabel('')
      }
    },
    // 气泡显示隐藏的回调
    addressPopStatus (val) {
      const show = !!val
      this.$emit('panel-change', show)
      this.changeSuffixIconSearchInput(show)
    },
    // 设置输入框箭头的方向
    changeSuffixIconSearchInput (show) {
      const searchRef = this.$refs.searchRef
      if (searchRef && isFunction(searchRef.changeSuffixIcon)) {
        searchRef.changeSuffixIcon(show)
      }
    },
    // 设置输入框的当前显示内容
    setInputLabel (label) {
      const searchRef = this.$refs.searchRef
      if (searchRef && isFunction(searchRef.setInputLabel)) {
        searchRef.setInputLabel(label)
      }
    },
    // 利用ID 改变城市面板展示数据
    async patchAreaTreeData (item, callback) {
      if (!item) {
        return
      }
      // console.log(item, '---下拉选中的数据----回显给面板')
      const { districtID } = item
      if (districtID) {
        const contentLayoutRef = this.$refs.contentLayoutRef
        if (contentLayoutRef && isFunction(contentLayoutRef.patchAreaTreeData)) {
          const selectedItem = await contentLayoutRef.patchAreaTreeData(item)
          isFunction(callback) && callback(selectedItem)
        }
      }
    },
    // 输入框清除操作逻辑
    clearSearchInput () {
      // 关闭的气泡以及输入框清空
      this.handleSearchListItemClickEvent(null)
      // 主动删除后，展示大区省份数据
      this._createAreaPanelBaseData()
      this.confirm(null)
      this.$emit('clear')
      this.updatePopper()
    },
    // 输入框 键盘 按下事件
    handleSearchKeyDownEvent (e) {
      const keyCode = e.keyCode
      const map = {
        13: () => { // enter键
          // 输入关键字之后如果模糊匹配到选项，按Enter键之后回显第一个选项
          // console.log('-----enter----')
          const { districtList } = this.inputSearchResult || {}
          const [firstItem] = districtList || []
          if (firstItem) {
            this.handleSearchListItemClickEvent(firstItem)
          }
        },
        38: () => { // ArrowUp键

        },
        40: () => { // ArrowDown键

        },
      }
      const iter = map[keyCode]
      isFunction(iter) && iter()
    },
    // 点击输入框之外的元素的逻辑
    inputClickoutside (e) {
      if (this.$props.disabled) {
        return
      }
      if (e && e.target) {
        let target = e.target
        const popper = this.$refs.addressPopRef.$refs.popper
        // 气泡内的逻辑元素不做处理
        if (popper && popper.contains(target)) {
          return false
        } else {
          this.selected && this.changeSelectedIter(this.selected, false)
        }
      }
    },
    // 处理输入框模糊搜索逻辑
    async handleSearchInputEvent (result, keyWord) {
      // console.log(result, '---result', keyWord)
      try {
        this.setShowPopover(true)
        this.setKeyWord(keyWord)
        if ((result && !result.districtList.length) && keyWord) {
          this.setInputSearchResult({
            keyWord,
            districtList: [false]
          })
        } else {
          this.setInputSearchResult(result)
        }
        this.updatePopper()
      } catch (error) {
        console.log(error)
      }
    },
    changeSelectedIter (selectedItem, isEmit = true) {
      const isAddress = this.$props.selectFullLevel
      const notEqualLevel = this.$props.level !== +selectedItem.level
      // 地址的时候 需要区分是否选择正确。 通过输入或区号匹配并选中结果如果不是完整的省市区，则选择后再次弹出面板自动定位到下一级，如果直接选到最后一级则不弹出面板。
      if (notEqualLevel && isAddress) {
        this.setShowPopover(true)
      } else {
        const { districtID } = selectedItem || {}
        const flatTreeNode = this.getAreaTreeNodeById(districtID)
        this.setShowFullLevelInputLabel(flatTreeNode)
        if (isEmit) {
          this.confirm(flatTreeNode)
        }
        this.setShowPopover(false)
      }
      this.setInputSearchResult(null)
      this.updatePopper()
    },
    // 选中模糊搜索下拉框的值
    handleSearchListItemClickEvent (item) {
      if (!item) {
        this.setInputSearchResult(null)
        return
      }
      this.patchAreaTreeData(item, (selectedItem) => this.changeSelectedIter(selectedItem, true))
    },
    // 城市面板点击选中时的回调
    handleAreaItemClickEvent (flatTreeNode) {
      this.$emit('area-item-click', flatTreeNode)
      if (this.$props.selectFullLevel) {
        // 地址必须 选到 规定的 level层级的最后一级。才可回填下拉框
        if (flatTreeNode && isPreventDownOnLevel(flatTreeNode.level, this.$props.level, 'equal')) {
          this.confirm(flatTreeNode)
        }
      } else {
        // 区域 可支持选择到任一级，每选一级都需要回填下拉框，选中任一级之后点击空白区域即可收起下拉面板
        this.confirm(flatTreeNode)
      }
    },
    updatePopper () {
      if (this.$refs.addressPopRef) {
        setTimeout(() => {
          this.$refs.addressPopRef && this.$refs.addressPopRef.popperJS && this.$refs.addressPopRef.popperJS.update()
        })
      }
    },
    confirm (item) {
      this.selected = item
      const confirmIter = (val) => {
        this.setShowFullLevelInputLabel(val)
        this.$emit('confirm', transFormConfirmData(val, this.$refs.searchRef.inputLabel))
      }
      if (item) {
        let flatTreeNode = transFormConfirmData(item, this.$refs.searchRef.inputLabel)
        // 是否存在选择完之后的回调。有则取对应的值
        const afterConfirm = this.$props.afterConfirm
        if (afterConfirm && isFunction(afterConfirm)) {
          let afterSelectedResult = afterConfirm(flatTreeNode, { getAreaTreeMap, getAreaTreeNodeById })
          if (afterSelectedResult.then) {
            afterSelectedResult.then(val => {
              confirmIter(val)
            })
          } else {
            confirmIter(afterSelectedResult)
          }
        } else {
          confirmIter(flatTreeNode)
        }
      } else {
        confirmIter(item)
      }
    },
    // 地址与区域选择之后 处理不同的输入框label逻辑
    setShowFullLevelInputLabel (item) {
      if (!item) {
        return
      }
      // 地址类型
      const flatTreeNode = this.getAreaTreeNodeById(item.districtID)
      const { districtName, parents, parentName, regionType, level, shortName } = flatTreeNode
      const emptyDistrictName = +regionType === 3 // 其他市县的标识
      let label = null
      const inputLabelDelimiter = this.$props.inputLabelDelimiter
      const _parentName = getLastSubstringAfterDash(parentName)
      const name = emptyDistrictName && !districtName ? _parentName : getLastSubstringAfterDash(districtName)
      if (this.$props.selectFullLevel) {
        // 地址模式下。
        /*
          1. regionType = 1 2 3 是直辖市 子同直辖市 其他市县 都不展示。
          2. level大于1 的不展示 即 中国 大区
        */
        const parentLabel = parents.reduce((str, ele) => {
          const name = getLastSubstringAfterDash(ele.districtName)
          if ((+ele.level > 1) && ![1, 3].includes(+ele.regionType)) { // 不显示存在 emptyLevel的值
            str.push(name)
          } else {
            if (name === OTHER_CITIES_COUNTIES) {
              str.push(name)
            }
          }
          return str
        }, [])
        shortName && parentLabel.push(name)
        label = parentLabel.join(inputLabelDelimiter)
        if (this.$props.level === +level) {
          this.setShowPopover(false)
        }
      } else {
        // 区域模式下
        /*
          1. regionType = 1 2 3 是直辖市 子同直辖市 其他市县  其他市县不展示。
        */
        if (name === OTHER_CITIES_COUNTIES) { // 中山这些子节点是不存在的
          label = _parentName + name
        } else {
          label = name
        }
      }
      this.setInputLabel(label)
    },
    // 设置用户的默认值于输入框和 城市数据面板
    getInputAreaDataByAreaId (val) {
      const item = formatterAreadResult({ areaId: val, areaName: this.$props.areaName })
      const { districtID } = item
      if (districtID) {
        this.patchAreaTreeData(item)
      } else {
        this.confirm(null)
        this._createAreaPanelBaseData()
        this.setInputLabel('')
      }
    },
    // 渲染大区-省份-数据，一般用于清除数据时
    _createAreaPanelBaseData () {
      const contentLayoutRef = this.$refs.contentLayoutRef
      if (contentLayoutRef && isFunction(contentLayoutRef._createAreaPanelBaseData)) {
        contentLayoutRef._createAreaPanelBaseData()
      }
    },
    getAreaTreeNodeById(districtID) {
      const flatTreeNode = getAreaTreeNodeById(districtID)
      return flatTreeNode
    }
  },
  watch: {
    areaId: {
      immediate: true,
      handler(val) {
        setTimeout(() => {
          this.getInputAreaDataByAreaId(val)
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/index.js